<template>
    <v-form-field v-bind="$props">
        <template v-slot:append>
            <slot name="append"></slot>
        </template>
        <template v-slot:label-prepend>
            <slot name="label-prepend"></slot>
        </template>
        <template v-slot:label-append>
            <slot name="label-append"></slot>
        </template>
        <template v-slot:label>
            <slot name="label"></slot>
        </template>
        <template v-slot:content>
            <v-select v-model="selectValue" class="form-input__border" solo flat
                      hide-details
                      :readonly="readonly"
                      :item-value="itemValue"
                      :item-text="itemText"
                      return-object
                      :clearable="clearable"
                      :disabled="disable"
                      :items="itemList" @change="onchange">
            </v-select>
        </template>
    </v-form-field>
</template>
<script>
    export default {
        name: "FormSelectorField.vue",
        props: {
            small: {
                type: Boolean,
                default: false
            },
            xSmall: {
                type: Boolean,
                default: false
            },
            xxSmall: {
                type: Boolean,
                default: false
            },
            middle: {
                type: Boolean,
                default: false
            },
            large: {
                type: Boolean,
                default: false
            },
            xLarge: {
                type: Boolean,
                default: false
            },
            xxLarge: {
                type: Boolean,
                default: false
            },
            label: {
                type: String
            },
            disable: {
                type: Boolean,
                default: false,
            },
            readonly: {
                type: Boolean,
                default: false
            },
            clearable: {
                type: Boolean,
                default: false
            },
            text: {},
            placeholder: {type: String},
            autofocus: {
                type: Boolean,
                default: false
            },
            labelWidth: {
                type: Number
            },
            fieldWidth: {
                type: Number
            },
            hideLabel: {
                type: Boolean,
                default: false
            },
            removeLabel: {
                type: Boolean,
                default: false
            },
            items: String,
            dataItems: {
                type: Array
            },
            value: null,
            dataApi: String,
            itemText: {
                type: String,
                default: 'text'
            },
            itemValue: {
                type: String,
                default: 'value'
            },
            numberValue: {
                type: Boolean,
                default: false
            },
            floatValue: {
                type: Boolean,
                default: false
            },
            dataQueryParam: {},
            vertical: {
                type: Boolean,
                default: false
            }
        },
        data() {
            return {
                itemList: [],
                selectValue: null
            }
        },
        watch: {
            value(val) {
                this.selectValue = val;
            },
            dataItems(val) {
                if (val) {
                    this.itemList = [];
                    val.forEach(x => this.itemList.push({text: x[this.itemText], value: x[this.itemValue]}));
                }
            },
            items(val) {
                this.parseExpression(this.items);
            }
        },
        created() {
            this.selectValue = this.value;
            if (this.dataApi) {
                this.loadRemoteApi();
            } else if (this.dataItems) {
                this.dataItems.forEach(x => this.itemList.push(x));
            } else {
                this.parseExpression(this.items);
            }
        },
        methods: {
            parseExpression(exp) {
                if (exp) {
                    let exps = exp.split(",");
                    this.itemList = [];
                    exps.forEach(item => {
                        let ss = item.split("|");
                        let v = ss.length > 1 ? ss[1] : ss[0];
                        if (this.floatValue) {
                            v = parseFloat(v);
                        } else if (this.numberValue) {
                            v = parseInt(v);
                        }
                        this.itemList.push({
                            text: ss[0],
                            value: v
                        })
                    })
                }
            },
            loadRemoteApi() {
                this.itemList = [];
                this.$request.request(this.dataApi, this.dataQueryParam).then(response => {
                    response.table.forEach(item => {
                        this.itemList.push(item);
                    })
                })
            },
            refreshParam(queryParam) {
                this.dataQueryParam = queryParam;
                this.loadRemoteApi();
            },
            onchange(val) {
                if (val) {
                    this.$emit('input', val[this.itemValue]);
                    this.$emit('change', val);
                } else {
                    this.$emit('input', null);
                }
            }
        }
    }
</script>